

























import {
  GridOptions,
  GridApi,
  ColumnApi,
  GridReadyEvent,
  ICellRendererParams,
} from 'ag-grid-community';
import { Vue, Component, Prop, Emit } from 'vue-property-decorator';
import ModalMantenedor from '@/reusable/Modal/ModalMantenedor.vue';
import { ServicioProxy, Accion } from '@/config/enums';
import CabeceraModal from '@/reusable/Modal/CabeceraModal.vue';
import { LoadingService } from '@/services/loadingService';
import { AxiosVue } from '@/AxiosVue';
import MantenedorGridVerDetalle from '@/reusable/Grid/MantenedorGridVerDetalle.vue';
@Component({
  components: {
    ModalMantenedor,
    CabeceraModal,
    MantenedorGridVerDetalle,
  },
})
export default class InfoCumplimientos extends Vue {
  @Prop({ required: true }) show: boolean;
  dialog: boolean = true;
  readonly gridOptions: GridOptions = null;
  enrichedGridOptions: GridOptions = null;
  axios: AxiosVue = new AxiosVue(ServicioProxy.Metabase);
  gridApi: GridApi;
  columnApi: ColumnApi;
  serverSide: any;
  readonly loadingService = new LoadingService();
  constructor() {
    super();
    this.gridOptions = {
      onGridReady: this.onGridReady, // Método que se ejecuta cuando la cuadrícula está lista
      rowSelection: 'multiple',
      pagination: true,
      paginationPageSize: 50,
      cacheBlockSize: 50,
      paginationAutoPageSize: false,
      serverSideDatasource: this.serverSide,
      rowModelType: 'serverSide',
      columnDefs: [
        {
          headerName: 'Item',
          field: 'item',
          resizable: true,
          minWidth: 300,
          maxWidth: 300,
          cellRenderer: this.gpsCellRenderer,
        },
        {
          headerName: 'Descripción',
          field: 'desc',
          resizable: true,
          minWidth: 800,
          maxWidth: 800,
        },
      ],
    };
  }
  gpsCellRenderer(params: ICellRendererParams) {
    const color = params.value === 'Item' ? 'red' : 'red';
    const span = document.createElement('span');
    span.style.display = 'flex';
    span.style.alignItems = 'center';
    span.innerHTML = `
      <span style="width: 10px; height: 10px; background-color: ${color}; border-radius: 50%; margin-right: 5px;"></span>
      ${params.value}
    `;
    return span;
  }
  async onGridReady(params: GridReadyEvent) {
    // Muestra el indicador de carga
    this.loadingService.showLoading();

    // Almacena las APIs de ag-Grid
    this.gridApi = params.api;
    this.columnApi = params.columnApi;

    const self = this;
    this.serverSide = {
      getRows(params: any): void {
        self.axios.http
          .post('Metabase/PostgenericA/certificador_bhp/getMensajes')
          .then((response: any) => {
            if (response.data.CODIGO_RESPUESTA == '1') {
              params.successCallback(
                response.data.data,
                response.data.data.length
              ); // Ejecuta el callback de éxito
              self.gridApi.hideOverlay();
            } else {
              // Lógica para manejar la respuesta fallida
              params.successCallback([], 0); // Ejecuta el callback de éxito con una matriz vacía
              self.gridApi.showNoRowsOverlay(); // Muestra la superposición cuando no hay filas
            }
            self.loadingService.hideLoading(); // Oculta el indicador de carga
          })
          .catch((error: any) => {
            console.log(error);
            self.gridApi.showNoRowsOverlay(); // Muestra superposición en caso de error
            self.loadingService.hideLoading(); // Oculta el indicador de carga
          })
          .finally(() => {
            // Lógica a ejecutar después de la llamada HTTP
            //self.gridApi.setDomLayout('autoHeight');
            self.loadingService.hideLoading();
          });
      },
    };

    // Configura el datasource del lado del servidor para la cuadrícula
    this.gridApi.setServerSideDatasource(this.serverSide);
  }

  autoSizeAll(skipHeader: boolean) {
    this.columnApi.autoSizeColumns(
      this.columnApi.getAllDisplayedColumns().map((x: any) => x.colId)
    );
  }

  handleCerrar() {
    this.$emit('update:value', false);
  }
}
